import React from "react";
import { Link } from "react-router-dom";
import BlogHeader from "./BlogHeader";
import BlogFooter from "./BlogFooter";
import ChecklistDownload from "./ChecklistDownload";
import "./Blog.css";
import "./BlogPostSafetyManager.css";
import "./BlogPostForeman.css";

function BlogPostTBM() {
  return (
    <div className="blog-wrap">
      <BlogHeader />
      <div className="blog-post-wrap">

        <div className="blog-post-header">
          <div className="blog-breadcrumb">
            <a href="/">현장통</a> › <Link to="/blog">현장가이드</Link> › <span>현장 운영</span>
          </div>
          <h1>TBM 매일 하는데<br />왜 기록이 없나 — 현장소장의 현실</h1>
          <div className="blog-post-meta">
            <span className="meta-tag" style={{ background: "#d1fae5", color: "#065f46" }}>현장 운영</span>
            <span className="meta-tag" style={{ background: "#d1fae5", color: "#065f46" }}>현장소장</span>
            <span>2026.06.05</span>
            <span>읽기 2분</span>
          </div>
        </div>

        <article className="sm-article">

          <div className="fm-hook">
            <p className="fm-hook-quote">"TBM은 매일 했는데 기록이 없습니다."</p>
            <p>산업재해 조사 현장에서 가장 많이 나오는 말 중 하나입니다.</p>
          </div>

          <p>TBM을 안 한 게 아닙니다. 매일 했습니다. 그런데 서류는 없습니다.</p>
          <p>어떻게 된 일인지 현장소장이라면 다 압니다.</p>

          <h2 className="sm-h2">8시 TBM, 끝나면 바로 작업 시작</h2>

          <p>TBM 마치면 인원 다 흩어집니다. 현장소장은 협력사 확인하러 가야 하고, 자재 반입도 확인해야 합니다.</p>
          <p>기록을 '나중에 사무실에서 써야지' 생각하고 넘어갑니다.</p>
          <p>그 '나중'이 오지 않습니다.</p>

          <div className="sm-insight">
            <div className="sm-insight-label">문제의 핵심</div>
            <p>기억에 의존하는 기록은 기록이 아닙니다.<br />시간이 지나면 내용도 날짜도 흐릿해집니다.</p>
          </div>

          <h2 className="sm-h2">TBM 기록, 5분이면 됩니다</h2>

          <p>길게 쓸 필요 없습니다. 세 가지만 남기면 됩니다.</p>

          <div className="fm-checklist">
            <div className="fm-check-item">
              <div className="fm-check-icon">①</div>
              <div>
                <div className="fm-check-title">참석자 명단 — QR + 전자서명</div>
                <div className="fm-check-desc">현장통 앱으로 참석자 QR코드를 찍으면 참석자 명단이 자동으로 구성되고, 참석자 전자서명까지 한 번에 갖춰진 TBM 일지가 완성됩니다.</div>
              </div>
            </div>
            <div className="fm-check-item">
              <div className="fm-check-icon">②</div>
              <div>
                <div className="fm-check-title">오늘 주요 위험 공지</div>
                <div className="fm-check-desc">오늘 어떤 위험을 공지했는지 한 줄. "고소작업 안전벨트 착용 강조" 이 정도면 충분합니다.</div>
              </div>
            </div>
            <div className="fm-check-item">
              <div className="fm-check-icon">③</div>
              <div>
                <div className="fm-check-title">특이사항</div>
                <div className="fm-check-desc">없으면 "특이사항 없음"이라고만 써도 됩니다. 공란보다 훨씬 낫습니다.</div>
              </div>
            </div>
          </div>

          <p>TBM 끝나고 현장에서 바로 스마트폰으로 입력하면 됩니다. 책상에 앉을 필요 없습니다.</p>

          <h2 className="sm-h2">습관이 되면 아무것도 아닙니다</h2>

          <p>처음 일주일이 어렵습니다. 손에 익으면 TBM 기록이 일과의 일부가 됩니다.</p>
          <p>기록이 쌓이면 한 달 뒤 감사가 나와도 꺼낼 서류가 있습니다.</p>

          <div className="fm-result-box">
            <div className="fm-result-before">
              <div className="fm-result-label bad">지금</div>
              <p>TBM 매일 함 → 기록 없음 → 감사 시 설명만 함</p>
            </div>
            <div className="fm-result-arrow">→</div>
            <div className="fm-result-after">
              <div className="fm-result-label good">5분 후</div>
              <p>TBM 매일 함 → 기록 쌓임 → 감사 시 서류 제출</p>
            </div>
          </div>

          <div className="sm-cta">
            <div className="sm-cta-question">TBM 기록, 현장에서 바로 하고 싶으신가요?</div>
            <p>현장통에서 TBM 참석자 체크부터 내용 입력까지<br />스마트폰으로 3분 안에 끝납니다.</p>
            <div className="sm-cta-buttons">
              <ChecklistDownload
                checklistTitle="작업 전 TBM 기록 체크리스트"
                pdf="/checklists/tbm-checklist.pdf"
                fileName="현장통_작업전_TBM기록_체크리스트.pdf"
                className="sm-cta-btn primary"
                label="무료 TBM 체크리스트 받기 →"
              />
              <a href="/#contact" className="sm-cta-btn secondary">
                무료체험 문의하기 →
              </a>
            </div>
          </div>

          <div className="blog-tags">
            {["#TBM", "#현장소장", "#건설현장안전", "#TBM기록", "#안전관리", "#현장통", "#건설안전앱"].map(tag => (
              <span key={tag}>{tag}</span>
            ))}
          </div>

          <div className="blog-related">
            <h3>다음으로 읽으면 좋은 글</h3>
            <div className="related-grid">
              <Link to="/blog/daily-record-3things" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">오늘 현장에서 꼭 남겨야 할 기록 딱 3가지</div>
              </Link>
              <Link to="/blog/safety-manager-paperwork" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">안전관리자가 서류에 치이는 진짜 이유</div>
              </Link>
              <Link to="/blog/serious-accident-law" className="related-card">
                <div className="related-card-tag">법규 가이드</div>
                <div className="related-card-title">중대재해처벌법 건설사 실무 대응 가이드</div>
              </Link>
            </div>
          </div>

        </article>

        <BlogFooter />

      </div>
    </div>
  );
}

export default BlogPostTBM;
